import { useState } from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faNoteSticky } from '@fortawesome/free-solid-svg-icons';
import { P, fs, radius } from '../theme/tokens';
import { relativeWhen } from '../utils/datetime';
import { GhostBtn } from './Buttons';
import { TextArea } from './Form';
import { Block, BlockHead, List, Muted } from './Modal/styled';

const EMPTY = [];

const NoteItem = styled.li`
  padding: 9px 11px;
  background: ${P.bgSubtle};
  border: 1px solid ${P.line};
  border-radius: ${radius.md}px;
  opacity: ${(p) => (p.$pending ? 0.6 : 1)};

  p {
    margin: 0;
    font-size: ${fs.sm}px;
    line-height: 1.45;
    color: ${P.ink};
    white-space: pre-line;
    text-wrap: pretty;
  }
  small {
    display: block;
    margin-top: 5px;
    font-size: 11px;
    color: ${P.subtle};
  }
`;

const NoteForm = styled.form`
  display: grid;
  gap: 8px;
  margin-top: 10px;

  textarea {
    min-height: 72px;
  }
  button {
    justify-self: end;
  }
  button svg {
    font-size: 11px;
  }
`;

function AddNote({ placeholder, onAdd }) {
  const [text, setText] = useState('');
  const submit = (e) => {
    e.preventDefault();
    const value = text.trim();
    if (!value) return;
    onAdd(value);
    setText('');
  };
  return (
    <NoteForm onSubmit={submit}>
      <TextArea aria-label="New note" placeholder={placeholder} value={text} onChange={(e) => setText(e.target.value)} />
      <GhostBtn type="submit" disabled={!text.trim()}>
        <FontAwesomeIcon icon={faNoteSticky} />
        Add note
      </GhostBtn>
    </NoteForm>
  );
}

export default function NotesThread({ notes = EMPTY, title = 'Notes on this record', emptyText, placeholder, onAdd }) {
  return (
    <Block>
      <BlockHead>
        <h3>{title}</h3>
        <span>{notes.length ? `${notes.length} ${notes.length === 1 ? 'note' : 'notes'}` : null}</span>
      </BlockHead>
      {notes.length ? (
        <List>
          {[...notes].reverse().map((n) => (
            <NoteItem key={n._id} $pending={n._id === 'pending'}>
              <p>{n.text}</p>
              <small>{[n.by, relativeWhen(n.createdAt)].filter(Boolean).join(' · ')}</small>
            </NoteItem>
          ))}
        </List>
      ) : (
        <Muted>{emptyText}</Muted>
      )}
      {onAdd && <AddNote placeholder={placeholder} onAdd={onAdd} />}
    </Block>
  );
}
